import { Box, Typography } from '@mui/material';

interface AssetCardProps {
  icon: React.ReactNode;
  name: string;
  size: string;
  date: string;
  onClick?: () => void;
}

const AssetCard = ({ icon, name, size, date, onClick }: AssetCardProps) => {
  return (
    <Box
      onClick={onClick}
      sx={{
        p: 2,
        borderRadius: '6px',
        border: '1px solid',
        borderColor: 'divider',
        cursor: 'pointer',
        transition: 'all 0.2s',
        '&:hover': {
          borderColor: 'primary.main',
          backgroundColor: 'action.hover',
        },
      }}
    >
      <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
        {icon}
        <Typography
          variant="body2"
          sx={{
            ml: 1,
            fontWeight: 500,
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
            flex: 1,
          }}
        >
          {name}
        </Typography>
      </Box>
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <Typography variant="caption" color="text.secondary">
          {size}
        </Typography>
        <Typography variant="caption" color="text.secondary">
          {date}
        </Typography>
      </Box>
    </Box>
  );
};

export default AssetCard;
